import { Column, Row, Text } from '@atom-web/micros'
import { isValidElement } from 'react'

export default ({ data = [], onClick = () => null, heading, groupKey }) => {
	return (
		<Column
			css={{
				gap: 24,
			}}
		>
			<Text
				css={{
					margin: 0,
					lineHeight: '26px',
					fontSize: 16,
					fontWeight: 600,
					color: '#333',
					userSelect: 'none',
				}}
			>
				{heading}
			</Text>
			<Column
				css={{
					gap: 20,
				}}
			>
				{data.length &&
					data.map(({ key, icon, name, checked }, index) => (
						<Row
							key={key + index}
							css={{
								gap: 10,
								alignItems: 'center',
								cursor: 'pointer',
							}}
							onClick={() =>
								onClick({
									groupKey,
									key,
									checked: !checked,
								})
							}
						>
							{isValidElement(icon) && icon}
							<Text
								css={{
									margin: 0,
									fontSize: 17,
									color: '#333',
									userSelect: 'none',
								}}
							>
								{name}
							</Text>
						</Row>
					))}
			</Column>
		</Column>
	)
}
